import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataRepresentative } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_REPRESENTATIVE = defineMasterdataEntity<MasterdataRepresentative>(
  {
    name: 'representative',
    responseKey: 'representatives',
    displayWith: (r) => keyName(r.key, r.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-user-tie',
    title: 'Vertretersuche',
    label: 'Vertreter',
    placeholder: 'Vertreter suchen...',
    columns: [
      {
        label: 'Vertreter',
        type: 'entity',
        icon: 'fa-regular fa-user-tie',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Nr.', value: (e) => e.key },
      { label: 'Bezeichnung', value: (e) => e.name },
      { label: 'Aktiv', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  }
);
